import { ApexOptions } from 'apexcharts';

const chartOptionsData: ApexOptions = {
  chart: {
    type: 'bar',
    stacked: true,
    animations: {
      speed: 300,
    },
    toolbar: {
      show: false,
      offsetX: 0,
      offsetY: -10,
      tools: {
        download: true,
      },
    },
  },
  legend: {
    position: 'top',
    fontSize: '14px',
    fontFamily: 'Helvetica, Arial',
    fontWeight: 400,
    horizontalAlign: 'right',
    labels: {
      colors: ['#344054', '#344054', '#344054', '#344054'],
      useSeriesColors: false,
    },
    markers: {
      width: 8,
      height: 8,
      fillColors: ['#026AA2', '#0BA5EC', '#EAECF0', '#FDA29B'],
      radius: 8,
    },
    itemMargin: {
      horizontal: 5,
      vertical: 0,
    },
    onItemClick: {
      toggleDataSeries: true,
    },
    onItemHover: {
      highlightDataSeries: true,
    },
  },
  dataLabels: {
    enabled: false,
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        legend: {
          position: 'bottom',
          offsetX: -10,
          offsetY: 0,
        },
      },
    },
  ],
  plotOptions: {
    bar: {
      horizontal: false,
      borderRadius: 10,
    },
  },
  xaxis: {
    categories: [],
  },
  yaxis: {
    show: true,
    showAlways: true,
    showForNullSeries: true,
    title: {
      text: 'Employees',
      rotate: -90,
      offsetX: -6,
      style: {
        fontSize: '12px',
        fontWeight: 500,
      },
    },
    tooltip: {
      enabled: true,
      offsetX: 0,
    },
  },
  fill: {
    opacity: 1,
    colors: ['#026AA2', '#0BA5EC', '#EAECF0', '#FDA29B'],
  },
};

export default chartOptionsData;
